import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useAuth } from "@/providers";
import { useDomainServices } from "@/providers/DomainServices";

import { CommentRecord } from "../CommentRecord";

import * as Comments from "./getQueryKey";

interface UpdateCommentParams {
  commentId: string;
  commentText: string;
}

/**
 * Hook for updating an existing comment.
 * Automatically invalidates comment queries on success.
 */
export function useUpdateComment() {
  const { commentService } = useDomainServices();
  const { currentOrganization } = useAuth();
  const queryClient = useQueryClient();

  return useMutation<CommentRecord, Error, UpdateCommentParams>({
    mutationFn: ({ commentId, commentText }: UpdateCommentParams) => {
      if (!currentOrganization?.org_id) {
        throw new Error("CurrentOrganization is not set");
      }

      return commentService.updateComment(commentId, commentText, {
        orgId: currentOrganization.org_id,
      });
    },
    onSuccess: () => {
      // Invalidate all comment queries to refetch with the updated comment
      void queryClient.invalidateQueries({
        queryKey: Comments.getQueryKey(),
      });
    },
  });
}
